/** The account to fall back on when nothing has named one: the autopay account, otherwise the most recently linked one. */
function getDefaultBankAccount(bankAccounts) {
    const autopayAccount = bankAccounts.find((account) => account.isAutopayBank);
    if (autopayAccount)
        return autopayAccount;
    return [...bankAccounts].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())[0];
}
export default getDefaultBankAccount;
